import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";
import { RoleProtectedRoute } from "./RoleProtectedRoute";

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
          <Route path="*" element={<Navigate to="/login" />} />
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => {
            // console.log("🚀 ~ {authProtectedRoutes.map ~ route:", route);
            
            // Determine the layout component
            let layoutElement;
            if (route.path === "/admin-docs-viewer/:id") {
              layoutElement = <NonAuthLayout>{route.component}</NonAuthLayout>;
            } else if (route.path === "/customer-docs-viewer/:id") {
              layoutElement = <NonAuthLayout>{route.component}</NonAuthLayout>;
            } else if (route.path === "/manifest-docs-viewer/:id") {
              layoutElement = <NonAuthLayout>{route.component}</NonAuthLayout>;
            } else {
              layoutElement = <VerticalLayout>{route.component}</VerticalLayout>;
            }

            // Wrap with role protection if requiredRoles is defined
            const element = route.requiredRoles ? (
              <AuthProtected>
                <RoleProtectedRoute 
                  component={layoutElement} 
                  requiredRoles={route.requiredRoles}
                  fallbackPath="/dashboard"
                />
              </AuthProtected>
            ) : (
              <AuthProtected>{layoutElement}</AuthProtected>
            );

            return (
              <Route
                path={route.path}
                element={element}
                key={idx}
                exact={true}
              />
            );
          })}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
